import React, { useState, useEffect, forwardRef } from "react";
import { Dropdown } from "primereact/dropdown";
import teachersAPI from "../../../../services/teachers";
import MeaUpdateModal from "../../../../components/MeaUpdateModal";
import sessionsAPI from "../../../../services/sessions";
import MeaButton from "../../../../components/MeaButton";

const UpdateSessionTeacherModal = forwardRef((props, ref) => {
  //
  const schoolId = props.schoolId;
  const trainingId = props.trainingId;
  const accessToken = props.accessToken;
  //
  const [teacher, setTeacher] = useState("-1");
  const [originalTeacher, setOriginalTeacher] = useState("-1");
  //
  useEffect(() => {
    setTeacher(props?.session?.teacher_id || "-1");
    setOriginalTeacher(props?.session?.schedule_item?.teacher_id || "-1");
  }, [props]);
  //
  const teachersList = teachersAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    100000
  );
  const uniqueTeachers = teachersList.data?.data || [];
  uniqueTeachers.sort((a, b) => a.member.lastname - b.member.lastname);
  const teachers = uniqueTeachers.map((teacher, index) => ({
    key: teacher.id,
    label: teacher.member?.name ? teacher.member?.name : teacher.member.lastname + " " + teacher.member.firstname,
    value: teacher.id,
  }));
  teachers.unshift({
    key: "empty-teacher-key",
    label: "",
    value: "",
  });
  //
  return (
    <>
      <MeaUpdateModal
        ref={ref}
        title="Enseignant(e) remplaçant(e)"
        serviceAPI={sessionsAPI}
        accessToken={accessToken}
        schoolId={schoolId}
        trainingId={trainingId}
        id={props?.session?.id}
        data={{
          teacher_id: teacher === "-1" ? "" : teacher,
        }}
        footerExtra={
          <MeaButton label="Réinitialiser" severity="danger" onClick={() => {
            setTeacher(originalTeacher);
          }} />
        }
      >
        <div className="card flex flex-column md:flex-row gap-3">
          <div className="p-inputgroup flex flex-column gap-2">
            <Dropdown
              id="enseignant"
              options={teachers}
              value={teacher || "-1"}
              onChange={(e) => setTeacher(e.value)}
              optionLabel="label"
              placeholder="Choisir un(e) Enseignant(e)"
              className="w-full mb-3"
            />
          </div>

        </div>
      </MeaUpdateModal>
    </>
  );
});

export default UpdateSessionTeacherModal;
